import {Component, HostListener, NgZone, OnDestroy, OnInit} from '@angular/core';
import {ServiceRequestAction, ServiceRequestService} from '../../services/service-request.service';
import {UrlService} from '../../services/url.service';
import {AuthenticationService} from '../../services/authentication.service';
import {ResidentService} from '../../services/resident.service';
import {flatMap, skip, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'service-request.component.html'
})
export class ServiceRequestComponent implements OnInit, OnDestroy {
    action = ServiceRequestAction;

    screenWidth = window.innerWidth;

    constructor(public serviceRequestService: ServiceRequestService,
                public urlService: UrlService,
                public residentService: ResidentService,
                private authenticationService: AuthenticationService,
                private ngZone: NgZone
    ) {
        window.onresize = (e) => {
            this.ngZone.run(() => {
                this.screenWidth = window.innerWidth;
            });
        };
    }

    ngOnInit() {
        if (!this.authenticationService.userIsResident) {
            this.serviceRequestService.getBuildings();
        }
        this.serviceRequestService.firstTimeLoading = true;

        this.urlService.onUrlChange
            .pipe(
                tap(() => {
                    this.serviceRequestService.showDetailedView = false;
                    this.serviceRequestService.selectedItemData = null;
                }),
                flatMap(
                    () => this.serviceRequestService.getDataByQueryParams(true)
                        .pipe(
                            takeUntil(this.urlService.instantOnUrlChange.pipe(skip(1))),
                        )
                ),
            )
            .subscribe();
        if (!this.urlService.queryParams['status'])
            this.urlService.queryParams['status'] = 'open,in_progress,on_hold';
        if (!this.urlService.queryParams['priority'])
            this.urlService.queryParams['priority'] = 'urgent,high,medium,low';
        this.urlService.setQueryParams('allServiceRequests');
        if (this.residentService.selectedBuilding.buildingId)
            this.residentService.getResidentServiceRequestPermissions();
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.serviceRequestService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.serviceRequestService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-request.component.ts